import { collection, doc, serverTimestamp, setDoc } from 'firebase/firestore'
import { userRef } from './alerts'
import { withoutNulls } from '@/firebase/converters'
import { getCurrentUserUid } from '@/firebase/auth'

/* The ONLY write this app performs:
 *
 *   ReassurancesRecord.createDoc(getUserRefFromUID(userId)).set({
 *     ...createReassurancesRecordData(sendersUserId: currentUserUid,
 *                                     alertId: alerts.first?.reference.id),
 *     ...mapToFirestore({'createdAt': FieldValue.serverTimestamp()}),
 *   })
 *
 * - the doc id is CLIENT-generated (createDoc -> doc(collection(...)));
 * - alertId is the alert's document ID, not a path;
 * - withoutNulls: a null alertId means the field is ABSENT, not null;
 * - sendersUserId is '' (not absent) when somehow signed out. */

export function writeReassurance(
  userId: string,
  alertId: string | null | undefined,
): Promise<void> {
  const parent = userRef(userId)
  const newDoc = doc(collection(parent.firestore, parent.path, 'reassurances'))
  return setDoc(newDoc, {
    ...withoutNulls({
      sendersUserId: getCurrentUserUid(),
      alertId: alertId ?? null,
    }),
    createdAt: serverTimestamp(),
  })
}
